export default __webpack_public_path__ + "static/media/Hood of the Faceless Sphinx.40f83f1b.jpg";